import { Text } from '@lmn/design-system';
import styled from 'styled-components';

export const TextBase = styled(Text).attrs({ variant: 'BodySmall' })``;
